import { render } from "./double_down_arrow.svg?vue&type=template&id=1b1b6ee4"
const script = {}
script.render = render

export default script